var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showLabel && _vm.label
        ? _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        _vm.iniDisabled ? "div" : "bDropdown",
        {
          tag: "component",
          staticClass: "dropdown dropdown-listed dropdown-workspaceuser",
          class: { "is-disabled": _vm.iniDisabled },
          attrs: {
            "aria-role": "menu",
            "mobile-modal": false,
            position: _vm.position,
            disabled: _vm.iniDisabled,
          },
          on: { "active-change": _vm.addFocus },
        },
        [
          _c(
            "a",
            {
              class: [
                "button is-trigger",
                _vm.condensed ? "is-icon" : "pl5-xs",
                !_vm.iniDisabled && _vm.v && _vm.v.$anyError
                  ? "is-danger"
                  : "is-cancel is-outlined",
              ],
              attrs: { slot: "trigger" },
              slot: "trigger",
            },
            [
              _vm.isLoading || (_vm.isFetching && !_vm.selectedValue)
                ? _c("loader", { attrs: { text: " " } })
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedValue &&
              (!_vm.isMultiple || _vm.selectedValue.length > 0)
                ? [
                    _vm.isMultiple
                      ? [
                          _vm._l(
                            _vm.selectedValue.slice(0, _vm.maxVisible),
                            function (user) {
                              return [
                                _c("UserAvatar", {
                                  key: user.id,
                                  staticClass: "sm m0",
                                  attrs: {
                                    firstName: user.profile.firstName,
                                    lastName: user.profile.lastName,
                                    url: user.profile.avatarUrl,
                                    condensed:
                                      _vm.condensed ||
                                      _vm.selectedValue.length > 1,
                                  },
                                }),
                              ]
                            }
                          ),
                          _vm._v(" "),
                          _vm.selectedValue.length > _vm.maxVisible
                            ? _c("span", { staticClass: "ml5-xs" }, [
                                _vm._v(
                                  "\n                        +" +
                                    _vm._s(
                                      _vm.selectedValue.length - _vm.maxVisible
                                    ) +
                                    "\n                    "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      : [
                          _c("UserAvatar", {
                            staticClass: "sm m0",
                            attrs: {
                              firstName: _vm.selectedValue.profile.firstName,
                              lastName: _vm.selectedValue.profile.lastName,
                              url: _vm.selectedValue.profile.avatarUrl,
                              condensed: _vm.condensed,
                            },
                          }),
                        ],
                    _vm._v(" "),
                    !_vm.condensed
                      ? [
                          _vm.showDetail
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "button is-detailMenu icon on-hover",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.showDetailClick(
                                        _vm.isMultiple
                                          ? _vm.selectedValue[0]
                                          : _vm.selectedValue
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "eye"] },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.iniDisabled
                            ? _c(
                                "span",
                                {
                                  staticClass: "icon m0",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.clear.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "times"] },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.condensed
                      ? [
                          !_vm.iniDisabled
                            ? _c(
                                "span",
                                { staticClass: "icon" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "angle-down"] },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ]
                : [
                    !_vm.iniDisabled && !_vm.isLoading
                      ? _c("div", { staticClass: "avatar sm m0 blank" }, [
                          _c(
                            "span",
                            { staticClass: "img" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "user"] },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.condensed
                            ? _c("div", { staticClass: "meta" }, [
                                _c("div", { staticClass: "name fade-50" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.showLabel && !_vm.iniDisabled
                                          ? _vm.$t(
                                              _vm.isMultiple
                                                ? "chooseUsers"
                                                : "chooseUser"
                                            )
                                          : ""
                                      ) +
                                      "\n                        "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.iniDisabled
                      ? _c(
                          "span",
                          { staticClass: "icon" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "angle-down"] },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          !_vm.iniDisabled
            ? [
                _vm.showCurrentUser
                  ? [
                      _c(
                        "b-dropdown-item",
                        { attrs: { "aria-role": "menu-item", "has-link": "" } },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "v-center",
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return ((e) =>
                                    _vm.onCheckbox(
                                      e,
                                      _vm.currentUser.Id
                                    )).apply(null, arguments)
                                },
                              },
                            },
                            [
                              _vm.isMultiple
                                ? [
                                    _c("chooseInput", {
                                      staticClass: "m0",
                                      attrs: {
                                        type: "CHECKBOX",
                                        value: _vm.currentUserIsSelected,
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c("UserAvatar", {
                                staticClass: "sm",
                                attrs: {
                                  firstName: _vm.currentUser.profile.firstName,
                                  lastName: _vm.currentUser.profile.lastName,
                                  url: _vm.currentUser.profile.avatarUrl,
                                  condensed: false,
                                },
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr", {
                        staticClass: "dropdown-divider",
                        attrs: { "aria-role": "menuitem" },
                      }),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSearch
                  ? [
                      _c(
                        "b-dropdown-item",
                        { attrs: { "aria-role": "menu-item", custom: "" } },
                        [
                          _c("textInput", {
                            ref: "search",
                            attrs: { type: "SEARCH" },
                            on: { input: _vm.doSearch },
                            model: {
                              value: _vm.searchTerm,
                              callback: function ($$v) {
                                _vm.searchTerm = $$v
                              },
                              expression: "searchTerm",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "head" }, [
                        _vm.count
                          ? _c("span", { staticClass: "mr5-xs" }, [
                              _vm._v(_vm._s(_vm.count)),
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("searchResults")) +
                            "\n                "
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.isLoading
                  ? _c(
                      "b-dropdown-item",
                      {
                        staticClass: "is-info",
                        attrs: { "aria-role": "menu-item" },
                      },
                      [_c("loader", { attrs: { text: _vm.$t("searching") } })],
                      1
                    )
                  : _vm.data && _vm.data.length == 0 && !_vm.isLoading
                  ? _c(
                      "b-dropdown-item",
                      {
                        staticClass: "is-info",
                        attrs: { "aria-role": "menu-item" },
                      },
                      [_vm._v(_vm._s(_vm.$t("noUsersFound")))]
                    )
                  : _vm.data && _vm.data.length > 0
                  ? _vm._l(_vm.data, function (item, index) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: index,
                          attrs: { "aria-role": "menu-item", "has-link": "" },
                        },
                        [
                          item._visible
                            ? _c(
                                "a",
                                {
                                  staticClass: "v-center",
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return ((e) =>
                                        _vm.onCheckbox(e, item.id)).apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.isMultiple
                                    ? [
                                        _c("chooseInput", {
                                          staticClass: "m0",
                                          attrs: {
                                            type: "CHECKBOX",
                                            value: item._selected,
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("UserAvatar", {
                                    staticClass: "sm",
                                    attrs: {
                                      firstName: item.profile.firstName,
                                      lastName: item.profile.lastName,
                                      url: item.profile.avatarUrl,
                                      condensed: false,
                                    },
                                  }),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  attrs: {
                    count: _vm.count,
                    hidePerPage: true,
                    iniPerPage: 10,
                  },
                  on: { input: _vm.paginateChange },
                  model: {
                    value: _vm.pagination,
                    callback: function ($$v) {
                      _vm.pagination = $$v
                    },
                    expression: "pagination",
                  },
                }),
                _vm._v(" "),
                _vm.showClearSelection
                  ? [
                      _c("hr", {
                        staticClass: "dropdown-divider",
                        attrs: { "aria-role": "menuitem" },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { "aria-role": "menu-item" },
                          on: { click: _vm.clear },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "icon" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "times"] },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("clearSelection")) + " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }